import React from 'react';
import { Sparkles } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const FeaturesIntro = () => {
  const { isDark } = useTheme();
  return (
    <section className="pt-14 pb-4 w-full">
      <div className="w-full px-4">
        <div className="text-center max-w-4xl mx-auto">
          <div className="mb-6">
            <span className={`inline-flex items-center text-[12px] font-medium px-4 py-2 rounded-[10px] ${
              isDark ? 'bg-[#17775510] text-[#28F5AB]' : 'bg-[#177755]/8 text-[#177755] border border-[#177755]/20'
            }`}>
              <Sparkles className="w-4 h-4 mr-2" />
              All-in-One AI Personalized Assistant
            </span>
          </div>
          <h2 className={`text-[28px] md:text-[40px] font-bold mb-3 ${isDark ? 'text-white' : 'text-[#0F172A]'}`}>
            Top 3 Features of Vuzo
          </h2>
          <p className={`text-[14px] md:text-[16px] leading-relaxed ${isDark ? 'text-gray-300' : 'text-[#64748B]'}`}>
            Discover what makes Vuzo stand out. Our top features are built to deliver powerful, reliable,<br />
            and easy-to-use AI solutions for everyone.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FeaturesIntro;
